import { Component, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './shared/seo/seo.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'reWire';

  constructor() {
    const router = inject(Router);
    const seo = inject(SeoService);
    // Routes flagged `data: { noindex: true }` (signed-in pages, 404) are kept
    // out of search results here, so no page component has to remember to.
    // Public pages set their own robots/canonical/JSON-LD via SeoService.setPage.
    const apply = () => {
      if (AppComponent.isNoindex(router.routerState.snapshot.root)) {
        seo.setRobots(true);
        seo.setJsonLd([]);
      }
    };
    // With initialNavigation 'enabledBlocking' the first navigation can finish
    // before this component exists, so check the current state once as well.
    apply();
    router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      takeUntilDestroyed(inject(DestroyRef)),
    ).subscribe(apply);
  }

  private static isNoindex(route: ActivatedRouteSnapshot | null): boolean {
    for (let r = route; r; r = r.firstChild) {
      if (r.data?.['noindex']) { return true; }
    }
    return false;
  }
}
